function EthnicitySelectAll(e) {
    if ($(e).is(':checked')) {
        $(e).parents('.ethnicity-group').find('.ethnicity-items input:checkbox').prop('checked', true);
    } else {
        $(e).parents('.ethnicity-group').find('.ethnicity-items input:checkbox').prop('checked', false);
    }

    UpdateEthnicity();
};

function EthnicitySelectItem(e) {
    if ($(e).is(':checked')) {
        if ($(e).parents('.ethnicity-items').find('input:checkbox:not(:checked)').length > 0) {
            $(e).parents('.ethnicity-group').find('.ethnicity-select-all input:checkbox').prop('checked', false);
        } else {
            $(e).parents('.ethnicity-group').find('.ethnicity-select-all input:checkbox').prop('checked', true);
        }
    } else {
        $(e).parents('.ethnicity-group').find('.ethnicity-select-all input:checkbox').prop('checked', false);
    }
    UpdateEthnicity();
};

function UpdateEthnicity() {
    var $ethnicitySelections = $('.ethnicity-container input:hidden');
    $ethnicitySelections.val('');

    var ethnicitySelections = new Array();
    $('.ethnicity-items input:checkbox:checked').each(function (i, o) {
        ethnicitySelections.push($(o).val() + ':' + $(o).attr('id'));
    });
    $ethnicitySelections.val(ethnicitySelections.join('~'));
};

